import { render, staticRenderFns } from "./VaultTransfer.vue?vue&type=template&id=712b3813&scoped=true&"
import script from "./VaultTransfer.vue?vue&type=script&lang=js&"
export * from "./VaultTransfer.vue?vue&type=script&lang=js&"
import style0 from "./VaultTransfer.vue?vue&type=style&index=0&id=712b3813&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b3813",
  null
  
)

export default component.exports